/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
import React, { useRef, useState } from 'react';
import cn from 'classnames';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import { Image } from 'shared';
import {
    Box,
    Grid, Heading, Text, useBreakpointValue,
} from '@chakra-ui/react';
// eslint-disable-next-line no-restricted-imports
import { Carousel } from 'shared/ui/Carousel';
import styles from './CrewMembersBlock.module.scss';
import { useCrewMembersBlockState } from '../store';

export type CrewMembersBlockProps = {
    className?: string
}

type CardProps = {
    name: string;
    jobTitle?: string | null | undefined;
    description?: any;
    image?: {
        url: string;
    } | null | undefined;
}

const Card: React.FC<CardProps> = ({
    name,
    jobTitle,
    description,
    image,
}) => {
    const [open, setOpen] = useState(false);

    const onMouseEnter = () => setOpen(true);

    const onMouseLeave = () => setOpen(false);

    return (
        <Grid
            gap="2rem"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <Grid aspectRatio="3 / 5" position="relative" animation="fade-in 500ms ease-out">
                <Image
                    pos="absolute"
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    src={image?.url || ''}
                />
                <Grid
                    height="100%"
                    templateRows="1fr auto auto auto"
                    gap="1rem"
                    zIndex={2}
                    padding="2rem"
                    margin="auto auto 0 0"
                    data-state={open ? 'open' : 'closed'}
                    transition="0.25s"
                    _open={{
                        margin: 'auto 0',
                        backdropFilter: 'blur(10px)',
                    }}
                    _closed={{
                        backdropFilter: 'blur(0px)',
                    }}
                >
                    <Grid />
                    <Grid
                        data-state={open ? 'open' : 'closed'}
                        gap="0.5rem"
                        _open={{
                            animation: 'fade-in 500ms ease-out',
                        }}
                    >
                        <Heading size="sm" background="black" color="white" padding="0.25rem" width="fit-content">
                            {name}
                        </Heading>
                        <Text background="black" color="white" padding="0.25rem" width="fit-content">
                            {jobTitle}
                        </Text>
                    </Grid>
                    <Grid
                        data-state={open ? 'open' : 'closed'}
                        color="white"
                        overflow="hidden"
                        _open={{
                            padding: '0.25rem',
                            background: 'black',
                            height: 'fit-content',
                            animation: 'fade-in 0.25s ease-in',
                        }}
                        _closed={{
                            padding: '0.25rem',
                            height: 0,
                            animation: 'fade-out 0.25s ease-out',
                        }}
                    >
                        {description && <BlocksRenderer content={description} />}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export const CrewMembersBlock = ({
    className,
}: CrewMembersBlockProps) => {
    const { crewMembers } = useCrewMembersBlockState();

    const slidesPerPage = useBreakpointValue(
        {
            base: 1,
            lg: 3,
        },
    );

    return (
        <Grid>
            <Grid
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                background="white"
                width="100%"
                margin="0 auto"
                gap="2rem"
                padding="2rem"
            >
                {/* <div className={styles.crewMembersBlock__backgroundBox} /> */}
                <Grid
                    templateColumns={{ base: '1fr', lg: 'auto 1fr' }}
                    gap="2rem"
                >
                    <Heading size="lg">
                        КОМАНДА
                    </Heading>
                    <Box margin="auto 0" background="black" height="4px" display={{ base: 'none', lg: 'block' }} />
                </Grid>
                <Grid position="relative">
                    <Carousel
                        maxWidth={{
                            base: '361px',
                            lg: '1216px',
                        }}
                        spacing="2rem"
                        slidesPerPage={slidesPerPage}
                        items={crewMembers.map(({
                            name, jobTitle, description, image,
                        }) => (
                            <Card name={name} jobTitle={jobTitle} description={description} image={image} />
                        ))}
                        // value={selected}
                        // onValueChange={(key) => setSelected(key)}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};
